(function(d){

  const mxform = d.getElementById('mxform');
  const ipts = mxform.querySelectorAll('[aria-required="true"]');
  const bttn = mxform.querySelector('button');
  const errors = [];
  const forEach = [].forEach;

  mxform.addEventListener('submit', e => {
    e.preventDefault();
    checkFields();
  });

  const checkFields = () => {

    forEach.call(ipts, el => {
      checkInput(el);
    });

    if (Object.keys(errors).length === 0) {
      pleaseWait();
      mxform.submit();
    }
  };

  const pleaseWait = () => {
    bttn.disabled = true;
    bttn.classList.add('working');
    bttn.textContent = 'Please wait...';
  };

  const isEmpty = element => {
    return !element.value.replace(/^\s+/g, '').length;
  };

  const validEmail = input => {
    const Regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;

    if (Regex.test(input.value)) {
      return true;
    } else {
      return false;
    }
  };

  const errBlock = (el, key) => {
    el.parentNode.classList.add('err');
    const label = el.previousElementSibling.textContent || 'Element';
    const maxLength = el.getAttribute('maxlength');
    const minLength = el.getAttribute('minlength');
    const errMsg = {
      message: {
        required: `${label} is required.`,
        email: `${label} must be formatted correctly.`,
        maxLength:`${label} length must be less than ${maxLength} characters.`,
        minLength:`${label} length must be greater than ${minLength} characters.`,
      }
    };
    const err = el.nextElementSibling;
    err.innerHTML = errMsg.message[key];
  };

  const clearErrors = el => {
    delete errors[el.name];
    el.parentNode.classList.remove('err');
  };

  const checkInput = el => {
    clearErrors(el);

    if (isEmpty(el)) {
      errors[el.name] = true;
      return errBlock(el, 'required');
    }

    if (el.getAttribute('type') === 'email' && !validEmail(el)) {
      errors[el.name] = true;
      return errBlock(el, 'email');
    }

    if (el.getAttribute('type') === 'hidden') {
      return;
    }

    if (el.getAttribute('maxlength') && el.length > el.getAttribute('maxlength')) {
      errors[el.name] = true;
      return errBlock(el, 'maxLength');
    }

    if (el.getAttribute('minlength') && el.length < el.getAttribute('minlength')) {
      errors[el.name] = true;
      return errBlock(el, 'minLength');
    }

    return true;
  };

}(document));
